import { z } from "zod/v4";

export const baseCallLogTextSchema = z.object({
  id: z.number(),
  content: z.string(),
  provider: z.string().nullable(),
});
